import * as React from "react";
const SvgFiRrFishBones = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fish-bones_svg__a)">
      <path
        fill="#062147"
        d="M6.5 19a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001M24 7c0 1.178-.78 2-1.898 2h-4.688l1.293 1.293a.999.999 0 1 1-1.414 1.414L15.5 9.914l-1.366 1.366 2.564 2.504a1 1 0 1 1-1.396 1.432l-2.582-2.521-1.306 1.306 3.293 3.293a.999.999 0 1 1-1.414 1.414L10 15.415l-.75.751a12.3 12.3 0 0 1 2.053 3.39 2.71 2.71 0 0 1-.08 2.209 2.7 2.7 0 0 1-1.7 1.406c-1.529.428-3.32.697-5.479.823a3.825 3.825 0 0 1-2.922-1.115 3.83 3.83 0 0 1-1.116-2.923c.126-2.153.395-3.945.824-5.479a2.7 2.7 0 0 1 1.408-1.701 2.7 2.7 0 0 1 2.207-.079 12.3 12.3 0 0 1 3.39 2.054L8.586 14l-3.293-3.293a.999.999 0 1 1 1.414-1.414L10 12.586l1.29-1.289-2.566-2.504a1 1 0 0 1 1.397-1.432l2.582 2.521 1.383-1.383-1.793-1.793a.999.999 0 1 1 1.414-1.414L15 6.585V1.898C15 .78 15.822 0 17 0c1.423 0 3.447.989 3.905 3.095C23.01 3.553 24 5.577 24 7M9.447 20.3A10.4 10.4 0 0 0 3.7 14.553a.7.7 0 0 0-.943.464c-.389 1.394-.636 3.047-.752 5.057a1.825 1.825 0 0 0 1.923 1.924c2.014-.118 3.667-.364 5.056-.753a.7.7 0 0 0 .464-.944zM22 7c0-.02-.117-2-2-2a1 1 0 0 1-1-1c0-1.858-1.93-1.997-1.998-2L17 7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fish-bones_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFishBones;
